export const CodeToInputGroupName: {[key: number]: string} = {
  11: 'fertilizer',
  12: 'pesticide',
  13: 'seed',
  14: 'employee',
  15: 'machinery',
  16: 'tool',
  17: 'farm',
  18: 'lab',
};
